import { ContentState, convertToRaw, EditorState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import React, { Component } from "react";
import { Button, Container } from "reactstrap";
import { Router, Styled } from "../../../toolkit/decorators/Artifact";
import { handleRequestError } from "../../../utils/helpers";
import {
  infoNotification,
  successNotification
} from "../../../utils/notifications";
import { saveContent, searchContentByType } from "../../actions/parameters";
import RichEditor from "../richEditorBig";
import s from "./styles.scss";

interface Props {}

interface State {
  data: any;
  saving: boolean;

  editorState: EditorState;
}

@Router()
@Styled(s)
export default class MaintenancesPricesGridComponent extends Component<
  Props,
  State
> {
  state = {
    saving: false,
    data: null,

    editorState: EditorState.createEmpty()
  };

  componentDidMount() {
    this.fetchInitialData();
  }

  fetchInitialData = async () => {
    searchContentByType("LEGALES_PARRILLA_PRECIOS")
      .then(({ data }) => {
        this.setState({
          data,
          saving: false,
          editorState: EditorState.createWithContent(
            ContentState.createFromBlockArray(
              htmlToDraft(data.contenido).contentBlocks
            )
          )
        });
      })
      .catch(handleRequestError);
  };

  onChangeEditor = editorState => this.setState({ editorState });

  save = e => {
    e.preventDefault();

    const { data, editorState } = this.state;

    this.setState({ saving: true });
    infoNotification("Guardando los datos");

    const contenido = draftToHtml(
      convertToRaw(editorState.getCurrentContent())
    );

    saveContent({ ...data, contenido })
      .then(() => {
        successNotification("Datos guardados correctamente");
        this.setState({ saving: false });
      })
      .catch(err => {
        this.setState({ saving: false });
        handleRequestError(err);
      });
  };

  render() {
    const { saving, editorState } = this.state;

    return (
      <Container className="mb-5">
        <div className="mt-4">
          <div className="mt-3 mb-3">
            <p className={`${s.primaryTitle} w-100 m-0`}>
              Parrilla de precios - Legales
            </p>
          </div>

          <div className=" mt-3 mb-3">
            <RichEditor
              style={{ height: "700px" }}
              onChangeEditor={this.onChangeEditor}
              editorState={editorState}
            />
          </div>

          <div className="mt-3 mb-3 text-right">
            <Button
              color="secondary"
              type="button"
              size="sm"
              onClick={this.save}
              disabled={saving}
            >
              Guardar
            </Button>
          </div>
        </div>
      </Container>
    );
  }
}
